<template>
  <b-card
    v-if="data"
    no-body
    class="list-group mb-1"
  >
    <!-- NOMBRE DE SECCIÓN -->
    <a
      href="javascript:void(0)"
      class="pt-0 pb-0 list-group-item list-group-item-action withripple active"
      @click="wantToRead =! wantToRead"
    >
      {{ data.nombre }}
    </a>

    <!-- DESCRIPCIÓN DE SECCIÓN -->
    <transition name="slide-fade">
      <div
        v-if="wantToRead && data.descripcion"
        class="text-white"
        style="background-color: #D3AF34; padding: 1rem; border-top: 1px dashed"
      >
        <p
          class="text-left m-0"
          style="line-height: normal; font-size: small;"
        >
          {{ data.descripcion }}
        </p>
      </div>
    </transition>

    <!-- ARCHIVOS -->
    <a
      v-for="file in data.files"
      :key="`${file.rutaDoc}${file.extBase}`"
      :href="`https://www.indetec.gob.mx/delivery?srv=0&sl=2&cat=8&path=${file.rutaDoc}${file.extBase}`"
      data-toggle="tooltip"
      data-placement="bottom"
      title="Click para descargar"
      target="_blank"
      class="pt-0 pb-0 list-group-item list-group-item-action withripple"
    >
      <feather-icon
        icon="FileIcon"
        class="mr-25"
      /> {{ file.descripcion }}
    </a>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'

import {
  BCard,
  // BButtonToolbar,
  // BButtonGroup,
  // BButton,
  // BSkeleton,
  // BSkeletonImg,
  // BSkeletonWrapper,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const wantToRead = ref(false)

    return {
      wantToRead,
    }
  },
}
</script>
